module.exports = __webpack_public_path__ + "media/images/b2b_admin/employees_shortcut_icon-2eaff2205dbff1124d4668dceea0710e.svg";